// Removes sentences / list fragments that advertise the 2nd-night discount when the offer is switched off.
export const stripDiscount = (text, enabled) => {
  if (enabled || !text) return text;
  return String(text)
    .split(/(?<=[.!?])\s+/)
    .filter((s) => !/\d+% off|% OFF|Stay Longer, Pay Less/i.test(s))
    .join(' ')
    .replace(/\s*·\s*$/, '');
};
